var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { width: 1200, "footer-hide": true, title: "现售单发货到转运站" },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.innerSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Card",
        { attrs: { padding: 0, bordered: false, "dis-hover": true } },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Form",
                    { ref: "deliveryForm", attrs: { "label-position": "top" } },
                    [
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "3" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "定单时间" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value: _vm.formatDateTimeString(
                                        _vm.orderRecord
                                          .curSaleOrderRecordCreateAt
                                      ),
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "定单编号" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.orderRecord.curSaleOrderRecordCode,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "会员名称" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.orderRecord.deliveryAddressContacts,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "会员电话" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.orderRecord.deliveryAddressPhone,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "3" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "定单状态" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.orderRecord
                                          .curSaleOrderRecordOrderStatus,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "3" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "本定单合计" } },
                                [
                                  _c("currency-input", {
                                    attrs: {
                                      value:
                                        _vm.orderRecord
                                          .curSaleOrderRecordTotalOrderCost,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "6" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "收货地址" } },
                                [
                                  _c("Input", {
                                    attrs: {
                                      value:
                                        _vm.orderRecord.deliveryAddressFull,
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "3" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "发货日期",
                                    prop: "curSaleDeliveryRecordDeliveryDate",
                                  },
                                },
                                [
                                  _c("DatePicker", {
                                    attrs: {
                                      value:
                                        _vm.deliveryTable.form
                                          .curSaleDeliveryRecordDeliveryDate,
                                      options: _vm.deliveryDateOptions,
                                      type: "date",
                                      format: "yyyy-MM-dd",
                                    },
                                    on: {
                                      "on-change": _vm.onDeliveryDateChange,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "7" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "备注" } },
                                [
                                  _c("Input", {
                                    model: {
                                      value:
                                        _vm.deliveryTable.form
                                          .curSaleDeliveryRecordRemark,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.deliveryTable.form,
                                          "curSaleDeliveryRecordRemark",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "deliveryTable.form.curSaleDeliveryRecordRemark",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: " " } },
                                [
                                  _c(
                                    "Button",
                                    {
                                      attrs: { type: "success" },
                                      on: { click: _vm.onSubmit },
                                    },
                                    [
                                      _vm._v(
                                        "提交送货单\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "定单商品" } },
                                [
                                  _c("Table", {
                                    ref: "mainTable",
                                    attrs: {
                                      size: "small",
                                      columns: _vm.orderDetail.columns,
                                      data: _vm.orderDetail.rows,
                                      height: 200,
                                      stripe: "",
                                      border: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                      },
                                    },
                                    [
                                      _c("span", [_vm._v("本次发货商品")]),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "red",
                                            "font-size": "16px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "共选择发货:" +
                                              _vm._s(
                                                _vm.deliveryTable.totalQuantity
                                              ) +
                                              "件"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c("Table", {
                                    ref: "deliveryTable",
                                    attrs: {
                                      size: "small",
                                      columns: _vm.deliveryTable.columns,
                                      data: _vm.deliveryTable.rows,
                                      height: 200,
                                      stripe: "",
                                      border: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.historyTable.columns,
                      size: "small",
                      data: _vm.historyTable.rows,
                      autoHeight: true,
                      loading: _vm.historyTable.loading,
                      "table-search": _vm.historyTable.search,
                      "table-load-event": _vm.getHistoryTableRecord,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Modal",
            {
              attrs: { title: "请选择发货的仓库", width: "75" },
              on: { "on-ok": _vm.onAddProducts },
              model: {
                value: _vm.warehouseModal.show,
                callback: function ($$v) {
                  _vm.$set(_vm.warehouseModal, "show", $$v)
                },
                expression: "warehouseModal.show",
              },
            },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c("Table", {
                        ref: "warehouseTable",
                        attrs: {
                          size: "small",
                          columns: _vm.warehouseModal.warehouseTable.columns,
                          data: _vm.warehouseModal.warehouseTable.rows,
                          stripe: "",
                          border: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }